export function check(val: any) {
  if (!val) {
    return false;
  }

  return [1, 2].includes(val);
}

export const Warning = {
  complete:
    'Tehtävää ei voida merkitä suoritetuksi, koska tehtävään liitettyjä tehtäviä on avoinna.',
  cancel:
    'Tehtävää ei voida merkitä peruutettu, koska tehtävään liitettyjä tehtäviä on avoinna.',
};
